import React from 'react';
import { CommandRegistry } from '../../../concepts/commands/CommandRegistry';
import { Input } from '../../../ui';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';

export type CommandDispatchSettingsProps = {
    settings: any[],
    onChange: (settings: any[]) => void,
};

export const CommandDispatchSettings = ({ settings, onChange }: CommandDispatchSettingsProps) => {

    const [name, ...args] = settings;

    const registry = useResolve(CommandRegistry);
    const command = registry.get(name);

    const setArg = (i: number) =>
        (value: string) => {
            while (args.length < (i + 1)) args.push('');
            args[i] = value;
            onChange([name, ...args]);
        };

    return <Flexer flex="column">
        {/* <Flexer flex="row">
            <Badge color={Colors.observe}>{command?.label}</Badge>
        </Flexer> */}
        {command?.wizard?.map((x, i) =>
            <Flexer key={x.name}>
                <Input before={x.message || x.name} compact value={args[i] || ''} onChange={setArg(i)} />
            </Flexer>
        )}
    </Flexer>;
};
